/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { KTSVG, toAbsoluteUrl } from '../../../helpers'
import { Dropdown1 } from '../../content/dropdown/Dropdown1'
import { ReviewActionsCell } from '../../../../app/modules/apps/artificial-intelligence/review-list/table/columns/ReviewActionsCell'
import { combineSelect2Values, getChannelImageUrl } from '../../../helpers/utility'
import { LanguageHelp } from '../../../helpers/LanguageHelper'

type Props = {
  className: string,
  row?: any
  reviewChannels?: any[]
}

const FeedsWidget1: React.FC<Props> = ({ className, row, reviewChannels }) => {
  const review = row?.original
  if (!review) {
    return null
  }

  let url = ""
  reviewChannels?.forEach((reviewChannel) => {
    if (reviewChannel.key === review.sourceId) {
      url = getChannelImageUrl(reviewChannel.type);
    }
  })

  return (
    <div className={`card ${className}`}>
      <div className='card-body pb-0'>
        <div className='d-flex align-items-center mb-5'>
          <div className='d-flex align-items-center flex-grow-1'>
            <div className='symbol symbol-45px me-5'>
              {url !== '' && <img src={toAbsoluteUrl(url)} alt='' />}
            </div>
            <div className='d-flex flex-column'>
              <div className='text-gray-800 fs-6 fw-bold'>
                {review.source}
              </div>
              <span className='text-gray-400 fw-semibold'>{review.createDate}</span>
            </div>
          </div>
          {review.reviewUrl !== null && review.reviewUrl !== '' &&
            <a href={review.reviewUrl} target='_blank' className='text-gray-800 text-hover-primary me-5' >
              &nbsp;<KTSVG path='/media/icons/duotune/arrows/arr095.svg' className='svg-icon-2' />
            </a>
          }
          <ReviewActionsCell isReviewLoading={false} id={review.id} status={review.status} />
        </div>
        <div className='mb-5'>
          <p className='text-gray-800 fw-normal mb-5'>
            {review.text}
          </p>

          <div className='d-flex align-items-center mb-5'>
            <div className={`btn btn-sm btn-light ${review.reviewViewCount === 0 ? 'btn-color-muted' : 'btn-light-success'} px-4 py-2 me-4`}>
              <i className="fa-solid fa-eye"></i>{review.reviewViewCount}
            </div>
            <div className={`btn btn-sm btn-light ${review.reviewCommentCount === 0 ? 'btn-color-muted' : 'btn-light-success'} px-4 py-2 me-4`}>
              <i className="fa-solid fa-message"></i>{review.reviewCommentCount}
            </div>
            <div className={`btn btn-sm btn-light ${review.reviewLikeCount === 0 ? 'btn-color-muted' : 'btn-light-success'} px-4 py-2 me-4`}>
              <i className="fa-solid fa-heart"></i>{review.reviewLikeCount}
            </div>
            {/* <div className={`btn btn-sm btn-light ${review.reviewDislikeCount === 0 ? 'btn-color-muted' : 'btn-light-danger'} px-4 py-2 me-4`}>
              <i className="fa-solid fa-heart-crack"></i>{review.reviewDislikeCount}
            </div> */}
            <div className={`btn btn-sm btn-light ${review.reviewShareCount === 0 ? 'btn-color-muted' : 'btn-light-success'} px-4 py-2 me-4`}>
              <i className="fa-solid fa-retweet"></i>{review.reviewShareCount}
            </div>
          </div>
        </div>

        <div className='separator mb-4'></div>

        <div className='d-flex'>
          <p className='text-dark fw-bold me-1'>{LanguageHelp('Sentiment')}: </p>
          <p className='text-gray-800 fw-normal'>{LanguageHelp(review.sentiment + '')}</p>
        </div>
        <div className='d-flex'>
          <p className='text-dark fw-bold me-1'>{LanguageHelp('Subjects')}: </p>
          <div>{combineSelect2Values(review.subjectList ?? [])}</div>
        </div>
        {(review.tagList?.length ?? 0) > 0 &&
          <div className='d-flex mb-5'>
            <p className='text-dark fw-bold me-1'>{LanguageHelp('Tag')}: </p>
            <div>{combineSelect2Values(review.tagList ?? [])}</div>
          </div>
        }

        {/* <form className='position-relative mb-6'>
          <textarea
            className='form-control border-0 p-0 pe-10 resize-none min-h-25px'
            rows={1}
            placeholder='Reply..'
          ></textarea>

          <div className='position-absolute top-0 end-0 me-n5'>
            <span className='btn btn-icon btn-sm btn-active-color-primary pe-0 me-2'>
              <i className="fas fa-paper-plane"></i>
            </span>
          </div>
        </form> */}
      </div>
    </div>
  )
}

export { FeedsWidget1 }
